import { ActionTypes } from "../contants/action-types";

const initialState = {
    txnCategory:[]
}

export const txnTypeCategoryReducer = (state=initialState, {type, payload})=>{
    switch(type){
        case ActionTypes.GET_TXN_TYPE_CATEGORY:
        //   return {...state, chartofAcconts:payload};
          return payload;
        default:
          return state;
    }

}